// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"136":"3aede920","865":"3aede920"}[chunkId] + ".css";
};